module.exports = __webpack_public_path__ + "dcb0f147cf649a219f9d1952aa1809d3.svg";